import React from "react";

function Welcome(){
    return (
        <div className="flex justify-center mt-10 mb-20">
  <div className=" w-[500px] sm:w-4/5 md:w-3/5 lg:w-2/5 text-center m-2 rounded-md shadow-xl shadow-black" style={{backgroundColor: "rgba(34,38,41,0.1)"}}>
    <h1 className="font-extrabold text-5xl lg:text-4xl md:text-3xl sm:text-2xl italic mt-5">Welcome!</h1>
    <p className="text-justify p-5 lg:text-lg md:text-base sm:text-sm text-gray-400">Welcome to the TSU 2023 Hackathon! We're excited to see all of the innovative ideas and projects that will be presented over the course of this event. Whether you're an experienced developer or just getting started, we hope that you'll find this to be a fun and rewarding experience. Good luck to all participants, and let's see what you can create!</p>
  </div>
</div>

    )
}

export default Welcome;